export const gtmPpCtaClickEvent = (button: string, productPageCategory: string) => ({
  event: 'pp_cta_click',
  button,
  pp_category: productPageCategory,
});

export default gtmPpCtaClickEvent;
